export const appVersionRefreshDialogId = 'app-version-refresh-dialog';
